import { render, staticRenderFns } from "./SideMenu.Vue?vue&type=template&id=129dd008"
import script from "./SideMenu.Vue?vue&type=script&lang=js"
export * from "./SideMenu.Vue?vue&type=script&lang=js"
import style0 from "./SideMenu.Vue?vue&type=style&index=0&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/SideMenu.Vue
// module id = 17
// module chunks = 0